import { render, staticRenderFns } from "./cg-event-boilerplate.vue?vue&type=template&id=15aed046&scoped=true"
import script from "./cg-event-boilerplate.vue?vue&type=script&lang=js"
export * from "./cg-event-boilerplate.vue?vue&type=script&lang=js"
import style0 from "./cg-event-boilerplate.vue?vue&type=style&index=0&id=15aed046&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aed046",
  null
  
)

export default component.exports